// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getNotes", "getVideo", "getGroups", "getTeachers", "getProducts"],
  endpoints: (builder) => ({
    fetchNotes: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getNotes"],
    }),
    getVideo: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getVideo"],
    }),
    getTeachers: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getTeachers"],
    }),

    getProducts: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getProducts"],
    }),
    getData: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    handlePatchRequest: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: data,
        };
      },

    }),
    updateIsLive: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: data,

        };
      },
      invalidatesTags: ["updateIsLive"],
    }),
    updateStrategy: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
      invalidatesTags: ["updateIsLiveStatus"],
    }),
    publish: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
    }),
    getTopicById: builder.mutation({
      query: ({ endpoint, updateSubject }) => ({
        url: endpoint,
        method: "GET",
        // body: updateSubject,
      }),
    }),
    getTopicByMultiId: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
    }),

    getSubTopicById: builder.mutation({
      query: ({ endpoint, updateSubject }) => ({
        url: endpoint,
        method: "GET",
        // body: updateSubject,
      }),
    }),

    getSubjectById: builder.mutation({
      query: ({ endpoint, updateSubject }) => ({
        url: endpoint,
        method: "GET",
        // body: updateSubject,
      }),
    }),
    getPlatformTypes: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    // uploadVideo: builder.mutation({
    //   query: ({ endpoint, file }) => {
    //     const formData = new FormData();
    //     formData.append("media", file);

    //     return {
    //       url: endpoint,
    //       method: "POST",
    //       body: formData,
    //     };
    //   },
    // }),
    uploadVideo: builder.mutation({
      query: ({ endpoint, file }) => {
        const formData = new FormData();

        // 🔥 EXACT key expected by backend
        formData.append("media", file);

        return {
          url: endpoint.startsWith("/") ? endpoint : `/${endpoint}`,
          method: "POST",
          body: formData,

          // 🔥 IMPORTANT FLAG
          formData: true,
        };
      },
    }),


  }),
});

export const {
  useFetchNotesQuery,
  useGetPlatformTypesQuery,
  usePublishMutation,
  useGetVideoQuery,
  useGetTeachersQuery,
  useGetProductsQuery,
  useGetDataQuery,
  useLazyGetVideoQuery,
  useLazyFetchNotesQuery,
  useHandlePatchRequestMutation,
  useUpdateIsLiveMutation,
  useUpdateStrategyMutation,
  useGetTopicByIdMutation,
  useGetTopicByMultiIdMutation,
  useGetSubTopicByIdMutation,
  useGetSubjectByIdMutation,

  useUploadVideoMutation
} = commonApi;
